import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HiChevronRight } from "react-icons/hi2";
import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Login from "../../pages/Login";
import { useMediaQuery } from "@/hooks/use-media-query";
import DomesticFlightIndividualItem from "./DomesticFlightIndividualItem";
import DomesticFlightDetailPreviewSheet from "./DomesticFlightDetailPreviewSheet";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export default function DomesticFlightListItem({
  flight,
  setSelectedFlightCallback,
  isSelected,
  isOutbount,
  isTwoWay,
  handleBookNowClickCallback
}) {
  const [flightDetailForPreview, setFlightDetailsForPreview] = useState({ flight });
  const [showPreview, setShowPreview] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 1024px)");


  return (
    flight && <>
      <Card className={cn("mb-3 border", isSelected ? "border-primary" : "border-transparent")}>
        <div className="flex items-start justify-between space-x-2 cursor-pointer px-2" onClick={() => { setSelectedFlightCallback && setSelectedFlightCallback(isSelected ? {} : flight) }}>
          {isTwoWay && <div className="pt-4  flex">
            <Checkbox
              id="select"
              checked={isSelected}
            />
            <label
              htmlFor="select"
              className={cn(isSelected && "text-primary", "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ms-2")}
            >

              {!isSelected ? "Select" : "Selected"}
            </label>
          </div>}
        </div>
        <div className={cn("text-sm p-2 md:p-2 px-3", isTwoWay && "cursor-pointer")} onClick={() => { setSelectedFlightCallback && setSelectedFlightCallback(isSelected ? {} : flight) }}>
          <div className={cn("col-span-6 grid grid-cols-3 gap-1 md:gap-4", !isTwoWay && "cursor-pointer")}
          // onClick={() => setShowPreview(true)}
          >
            <DomesticFlightIndividualItem
              flight={flight}
              array={[]}
              key={0}
              carrier={flight.AirlineName}
            />
          </div>
          <div class="flex border-t px-4 py-2 items-center">
            <div class="flex-1 flex justify-end pe-4">
              <div class="flex items-end space-x-2 py-2">
                <label class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" for="list4QOWNP">
                  <span class="block text-2xs text-muted-foreground">
                  </span>
                  <span className="text-lg font-semibold pt-2"><span className="text-sm">{flight.Currency + " "}</span>{flight.TotalFare}</span>

                </label>
              </div>
            </div>
            {!isTwoWay && <div class="ps-4 border-s border-dotted">
              <Button onClick={() => handleBookNowClickCallback(flight)}>Book Now </Button>
            </div>
            }
          </div>
        </div>

        <div className="flex items-center justify-between dark:bg-gray-700 bg-gray-200/50 px-3">
          {flight.Refundable == "0" ? (
            <span className="text-muted-foreground text-sm">Non-Refundable</span>
          ) : flight.Refundable == "1" ? (
            <span className="text-primary text-sm">Refundable</span>
          ) : <></>}
          <Button
            onClick={() => {
              setShowPreview(true);
            }}
            variant="link"
            className="px-0"
          >
            Flight Details
            <HiChevronRight className="ml-2" />
          </Button>
        </div>
      </Card>
      {flightDetailForPreview && (
        <DomesticFlightDetailPreviewSheet
          key={"FlightDetailPreview"}
          open={showPreview}
          openchange={setShowPreview}
          flightInfo={flight}
          handleBookItemCallback={(flight) => {
            handleBookNowClickCallback(flight)
          }}
          isOutbount={isOutbount}
          isTwoWay={isTwoWay}
        />
      )
      }
      <Dialog
        open={showLoginForm}
        onOpenChange={setShowLoginForm}
      >
        <DialogContent>
          <Login
            fromLogin
            handleClose={(resp) => setShowLoginForm(resp)}
          />

          {/* <DialogFooter>
          <Button type="submit">Save changes</Button>
        </DialogFooter> */}
        </DialogContent>
      </Dialog>
    </>

  );
}
